"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Confirm;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _DialogBox = _interopRequireDefault(require("../DialogBox/DialogBox"));
var _Button = _interopRequireDefault(require("../Button/Button"));
/**
 * A generic confirm modal built on top of DialogBox.
 * Most properties are optional with default values.
 * Required properties are commented as such.
 */

function Confirm(_ref) {
  let {
    confirmButtonDisabled,
    confirmButtonIcon,
    confirmButtonId,
    confirmButtonPriority,
    confirmButtonText,
    confirmButtonType,
    closeButtonId,
    closeButtonText,
    message,
    onClose,
    onConfirm,
    open,
    size,
    textStyle,
    title
  } = _ref;
  const theme = (0, _material.useTheme)();
  const middleButtons = (0, _react.useMemo)(() => {
    const buttons = [/*#__PURE__*/_react.default.createElement(_Button.default, {
      disabled: confirmButtonDisabled,
      icon: confirmButtonIcon,
      id: confirmButtonId || 'confirm-submit',
      key: "button-2",
      label: confirmButtonText,
      onClick: onConfirm,
      priority: confirmButtonPriority || 'primary',
      type: confirmButtonType || 'productive'
    })];
    if (onClose && closeButtonText) {
      buttons.unshift( /*#__PURE__*/_react.default.createElement(_Button.default, {
        id: closeButtonId || 'confirm-close',
        key: "button-1",
        label: closeButtonText,
        onClick: onClose,
        priority: "secondary",
        type: "passive"
      }));
    }
    return buttons;
  }, [confirmButtonDisabled, confirmButtonIcon, confirmButtonId, confirmButtonPriority, confirmButtonText, confirmButtonType, closeButtonId, closeButtonText, onClose, onConfirm]);
  const content = (0, _react.useMemo)(() => {
    const text = (str, key) => {
      return /*#__PURE__*/_react.default.createElement(_material.Typography, {
        color: theme.palette.TwClrTxt,
        fontSize: "16px",
        fontWeight: 400,
        key: key,
        lineHeight: "24px",
        textAlign: "center",
        sx: {
          marginBottom: theme.spacing(1),
          '&:last-child': {
            marginBottom: 0
          },
          ...(textStyle || {})
        }
      }, str);
    };
    if (typeof message === 'string') {
      return text(message);
    } else if (Array.isArray(message)) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, message.map((str, i) => text(str, "".concat(str, "_").concat(i))));
    } else {
      return message;
    }
  }, [message, textStyle, theme]);
  return /*#__PURE__*/_react.default.createElement(_DialogBox.default, {
    onClose: onClose,
    open: open !== null && open !== void 0 ? open : true,
    title: title,
    size: size || 'medium',
    middleButtons: middleButtons
  }, content);
}